import styled from 'styled-components';
import { StyledContentCard } from 'modules/intelligentInsights/brandAffinityInsights/components/common.styles';
import {
  borderRadius,
  colors,
  heading5,
  monochromeLink,
  Overline,
  spacing,
  subtitle1,
} from 'ui/theme';
import { IconButton } from 'ui/button';
import { pxToRem } from 'utils/convert';

export const AffinityTrendsCard = StyledContentCard;

export const AffinityTrendsFlexRowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const AffinityTrendsFlexResponsiveContainer = styled(AffinityTrendsFlexRowContainer)`
  @media screen and (width <= 1280px) {
    flex-direction: column;
    gap: ${spacing.double};
    width: 100%;
  }
  align-items: flex-start;
  gap: ${spacing.double};
`;

export const AffinityTrendsGraphWrapper = styled.div`
  flex: 2 0 0;
  width: 100%;
  max-width: none;
`;

export const AffinityTrendsDeltasWrapper = styled.div`
  flex: 0 0 ${pxToRem(420)};
`;

export const AffinityTrendsStyledLeftHeader = styled.h5`
  ${heading5};
  margin: 0;
`;

export const AffinityTrendsStyledRightHeader = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
`;

export const AffinityTrendsExportButton = styled(IconButton)`
  margin-left: ${spacing.quarter};
  z-index: 0;
`;

export const AffinityTrendsDeltasGridContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  gap: ${spacing.base};
  padding: ${spacing.plusHalf};
  padding-bottom: ${spacing.half};
  background-color: ${colors.backgroundSecondary};
  border-radius: ${borderRadius.lg};
  height: 100%;
`;

export const AffinityTrendsDeltaContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  &:not(:last-of-type) {
    border-bottom: ${spacing.single} solid ${colors.borderPrimary};
    padding-bottom: ${spacing.half};
  }

  & > *:last-child {
    margin-top: ${spacing.half};
    margin-bottom: ${spacing.half};
  }
`;

export const AffinityTrendsDeltaContentTitle = styled(Overline)`
  margin: 0;
  color: ${colors.textSecondary};
`;
export const AffinityTrendsDeltaMovementText = styled.span`
  ${subtitle1};
`;
export const AffinityTrendsDeltaContentSecondary = styled(AffinityTrendsDeltaMovementText)`
  color: ${colors.textSecondary};
`;
export const AffinityTrendsDeltaLink = styled.div`
  ${monochromeLink};
  color: ${colors.textSecondary};
`;
export const AffinityTrendsDeltaUnscoredTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;
